import api from './axios';

// Daily Tasks
export const getFacilityTasks = () =>
  api.get('/facility-compliance/tasks').then(r => r.data);

export const createFacilityTask = (data) =>
  api.post('/facility-compliance/tasks', data).then(r => r.data);

export const updateFacilityTask = (id, data) =>
  api.put(`/facility-compliance/tasks/${id}`, data).then(r => r.data);

export const deleteFacilityTask = (id) =>
  api.delete(`/facility-compliance/tasks/${id}`).then(r => r.data);

export const completeFacilityTask = (id, notes, time_spent, date) =>
  api.post(`/facility-compliance/tasks/${id}/complete`, { notes, time_spent, ...(date ? { date } : {}) }).then(r => r.data);

export const uncompleteFacilityTask = (id) =>
  api.delete(`/facility-compliance/tasks/${id}/complete`).then(r => r.data);

export const updateFacilityTaskCompletion = (id, notes, time_spent) =>
  api.put(`/facility-compliance/tasks/${id}/complete`, { notes, time_spent }).then(r => r.data);

// Complaints
export const getFacilityComplaints = (status) =>
  api.get('/facility-compliance/complaints', { params: status ? { status } : {} }).then(r => r.data);

export const createFacilityComplaint = (formData) =>
  api.post('/facility-compliance/complaints', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);

export const assignFacilityComplaint = (id, assigned_to) =>
  api.post(`/facility-compliance/complaints/${id}/assign`, { assigned_to }).then(r => r.data);

export const resolveFacilityComplaint = (id, est_fix_time, resolution_notes, time_spent) =>
  api.post(`/facility-compliance/complaints/${id}/resolve`, { est_fix_time, resolution_notes, time_spent }).then(r => r.data);

// Other Works
export const getFacilityOtherWorks = () =>
  api.get('/facility-compliance/other-works').then(r => r.data);

export const createFacilityOtherWork = (data) =>
  api.post('/facility-compliance/other-works', data).then(r => r.data);

export const updateFacilityOtherWork = (id, data) =>
  api.put(`/facility-compliance/other-works/${id}`, data).then(r => r.data);

export const deleteFacilityOtherWork = (id) =>
  api.delete(`/facility-compliance/other-works/${id}`).then(r => r.data);

export const markFacilityOtherWorkDone = (id, notes, time_spent) =>
  api.post(`/facility-compliance/other-works/${id}/done`, { notes, time_spent }).then(r => r.data);

export const getFacilityWorkLog = (date, user_id) =>
  api.get('/facility-compliance/work-log', { params: { date, user_id } }).then(r => r.data);

export const getFMUsers = () =>
  api.get('/facility-compliance/fm-users').then(r => r.data);

// Users list (for assignment)
export const getFacilityUsers = () =>
  api.get('/admin/users').then(r => r.data);
